import { ErrorMessage } from '@vwfs-bronson/bronson-react';

interface OwnProps {
  errorMessage: string;
  id?: string;
}

export const FieldError: React.FunctionComponent<OwnProps> = ({
  errorMessage,
  id
}): JSX.Element | null => {
  return errorMessage ? (
    <ErrorMessage id={id} className="c-error-message u-ml-none">
      {errorMessage}
    </ErrorMessage>
  ) : null;
};
